import { apiGet } from "../../api/client";

export interface CurrencyRate {
  code: string;
  name: string;
  symbol: string;
  rate_to_rub: number | null;
  updated_at: string | null;
}

interface CurrenciesResponse {
  ok: boolean;
  rows: CurrencyRate[];
}

export function getCurrencies(signal?: AbortSignal): Promise<CurrenciesResponse> {
  return apiGet<CurrenciesResponse>("/api/v1/currencies", signal);
}
